// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsForm__e1d {
  margin-top: var(--ring-unit);
  display: flex;
  flex-direction: column;
  gap: calc(var(--ring-unit) * 2);
}

.container__aa4 {
  display: flex;
  flex-direction: column;
  gap: var(--ring-unit);
  margin-top: calc(var(--ring-unit) * 2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/profiles/profile-details/profile-ai/ai-available/ai-tools/ai-tools.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;AACxC","sourcesContent":[".settingsForm {\n  margin-top: var(--ring-unit);\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--ring-unit) * 2);\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ring-unit);\n  margin-top: calc(var(--ring-unit) * 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsForm": `settingsForm__e1d`,
	"container": `container__aa4`
};
export default ___CSS_LOADER_EXPORT___;
